module.exports = __webpack_public_path__ + "img/21.ed18d4c2.png";